/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heroic_Formal_Dolphin_RiseInputs */

const fr_heroic_formal_dolphin_rise = /** @type {(inputs: Heroic_Formal_Dolphin_RiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions`)
};

/**

* @param {Heroic_Formal_Dolphin_RiseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const heroic_formal_dolphin_rise = /** @type {((inputs?: Heroic_Formal_Dolphin_RiseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heroic_Formal_Dolphin_RiseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_heroic_formal_dolphin_rise(inputs)
});